<template>
    <div>
      <navbar :title="fad" :box="box"/>
        <van-tabs v-model="active">
          <van-tab title="Hesap">
            <van-field v-model="ref_kod" disabled label="Sponsor"/>
            <van-field v-model="uye_kod" disabled label="Üye Kodu"/>
            <van-field v-model="uye_ad" disabled label="Üye Adı"/>
            <van-field v-model="parola" type="password" label="Parola"/>
        
            <van-button @click="passupdate()" style="margin-top:15px" type="info" size="large">Hesap Bilgilerini Güncelle</van-button>
          </van-tab>
          <van-tab title="Genel">
<van-form @submit="onUpdate('update_uye_bilgi',genel,'UyeBilgi')">
  <van-field
    v-model="UyeBilgi.email"
    label="E-Posta"
    name="E-posta"
    placeholder="E-posta Adresi"
    :rules="[{ required: true, message: 'E-Posta boş geçilemez' }]"
  />
    <van-field
    v-model="UyeBilgi.gsm"
    label="Telefon"
    placeholder="Mobil Telefon"
    :rules="[{ required: true, message: 'Telefon boş geçilemez' }]"
  />
  <van-field
    v-model="UyeBilgi.il"
    label="İl"
    placeholder="il"
    :rules="[{ required: true, message: 'il boş geçilemez' }]"
  />
  <van-field
    v-model="UyeBilgi.ilce"
    label="İlçe"
    placeholder="ilçe"
    :rules="[{ required: true, message: 'ilçe boş geçilemez' }]"
  />
  <van-field
    v-model="UyeBilgi.adres"
    label="Adres"
    placeholder="Kısace Adresiniz"
    :rules="[{ required: true, message: 'Adres boş geçilemez' }]"
  />
<div v-if="UyeBilgi.tip===1">
  <van-field
    v-model="UyeBilgi.unvan"
    label="Ünvan"
    name="unvan"
    placeholder="Fatura Başlığı"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
    <van-field
    v-model="UyeBilgi.vd"
    label="Vergi D."
    placeholder="Vergi Dairesi"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
  <van-field
    v-model="UyeBilgi.vno"
    label="Vergi No"
    placeholder="Vergi Numarası"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
  <van-field
    v-model="UyeBilgi.fadres"
    label="Adres"
    placeholder="Fatura Adresi"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />  
</div>
<!--kurumsal -->

  <div style="margin:16px;">
    <van-button style="margin-top:15px" type="info" size="large" native-type="submit">Genel Bilgileri Güncelle
    </van-button>
  </div>
</van-form>
</van-tab>
<van-tab title="Banka">
  <van-form @submit="onUpdate('update_banka_bilgi',banka,'Banka')">
    <van-field
    v-model="Banka.banka_adi"
    label="Banka"
    placeholder="Banka Adı"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
    <van-field
    v-model="Banka.iban_no"
    label="Iban"
    placeholder="iban no"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  /> 
    <van-field
    v-model="Banka.hesap_sahip"
    label="Hesap"
    placeholder="Hesap Sahibi"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  /> 
    <van-field
    v-model="Banka.sube_adi"
    label="Şube"
    placeholder="Şube Adı"
    
  />
  <van-field
    v-model="banka.sube_kodu"
    label="Şube Kodu"
    placeholder="Şube Kodu"
    
  />
  <van-field
    v-model="banka.hesap_no"
    label="Hesap No"
    placeholder="Hesap no"
   
  />  
  <div style="margin: 16px;">
    <van-button type="info" size="large" native-type="submit">Banka Bilgileri Güncelle</van-button>
  </div>
  </van-form>
</van-tab>
</van-tabs>
  <van-button @click="cikis" style="margin-top:15px" type="danger" size="large">Güvenli Çıkış</van-button>
    <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import navbar from './nav'
import {Toast} from 'vant'
export default {
components:{
navbar
},
  data() {
    return {
      UyeBilgi:{},
      Banka:{},
      show:false,
      active:0,
      fad:'Hesabım',
      ref_kod:helper.settings.ayar().referans,
      uye_kod:helper.settings.ayar().uye,
      uye_ad:helper.settings.ayar().uye_ad,
      parola:helper.settings.ayar().pass,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0
    };
  },
  created (){
    this.show = true
    userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {
      this.genel()
      this.banka()
      }
    )
    .catch(err => {userService.logout()})
  },
    methods : {
      onUpdate(geti,callback,data){
        this.show = true
        let datas
        if (data === 'UyeBilgi') {datas = this.UyeBilgi}
        else{datas = this.Banka}
        helper.request.post(geti,datas)
        .then(res=>{
          Toast("Güncelleme Başarılı")
          callback()
        })
        .catch(err => {
          Toast("Tekrar Dene : "+err )
        })
      },

      genel(){
        helper.request.get('tbl_bilgi/'+this.uye_kod+'/tbl_uye_bilgi')
        .then(res=>{
          this.UyeBilgi = res
          this.show = false
        })
      },

      banka(){
        helper.request.get('tbl_bilgi/'+this.uye_kod+'/tbl_uye_banka')
        .then(res=>{
          this.Banka = res
          this.show = false
        })
      },

      cikis(){
        this.show = true
        userService.logout();
      },
      passupdate(){
        if (this.parola && this.parola.length>=6)
        {
        this.show = true
        let data = {
          parola : this.parola,
          uye_kod:helper.settings.ayar().uye
        }
        helper.request.post("update_genel_bilgi", data)
        .then(res => {
          Toast('Güncelleme Başarılı')
          this.show = false
        })
        .catch(err => {Toast(err)
        this.show = false
        })
      }
      else{Toast('Şifre boş olamaz ya da min 6 karakter')}
      },

     

  } 
};
</script>


// WEBPACK FOOTER //
// src/components/hesap.vue